import React from "react";
import ComingSoonPitch, {
  Benefit,
} from "../../shared/components/ComingSoonPitch";
// The phone mock is the design team's own artwork, taken in whole rather than
// rebuilt out of markup: it is a picture of the client app, not a working
// preview of it, and every pixel in it — the meal photo, the macro bars, the
// tab bar — is decoration that nothing on this screen reads or changes.
import clientAppMock from "../../../assets/svg/Launch-app/launch app.svg";
import mealLoggingIcon from "../../../assets/svg/Launch-app/launch-1.svg";
import progressIcon from "../../../assets/svg/Launch-app/launch-2.svg";
import brandingIcon from "../../../assets/svg/Launch-app/launch-3.svg";

/**
 * The three the design leads with — the ones that answer "what would my clients
 * actually do with it", in the order they would meet them: log a day, see the
 * weeks add up, and never once see our name.
 */
const BENEFITS: Benefit[] = [
  {
    icon: mealLoggingIcon,
    title: "Daily meal & water logging",
    detail: "Clients track intake in seconds, you see it all",
  },
  {
    icon: progressIcon,
    title: "Progress they can feel",
    detail: "Weight, measurements and photos over time",
  },
  {
    icon: brandingIcon,
    title: "Fully your brand",
    detail: "Your logo, colors and name - not ours",
  },
];

/** The client app, before it exists: what it will be, shown rather than told. */
const LaunchAppPage: React.FC = () => (
  <ComingSoonPitch
    title="Launch app"
    heading="Give every client their own app."
    subheading="Set up the branded app your clients use to log meals, track progress, and stay on plan."
    benefits={BENEFITS}
    artwork={
      // The phone stands up against the top border of the card and takes
      // nearly its whole height, as the design has it. Sized off that height
      // rather than set at a width: the card's height is the portfolio mock's
      // — see `ComingSoonPitch` — and a phone left at a fixed width either
      // falls short of the top edge or runs past the bottom one as that height
      // changes between breakpoints.
      //
      // It is never cropped, though, unlike the portfolio mock beside it: it is
      // a device, and a device cut off by the edge of a panel reads as a
      // rendering mistake rather than a picture. So on the narrow screens where
      // half a card is narrower than the phone that height asks for,
      // `object-contain` sizes it down to fit instead, and `object-top` keeps
      // it against the top edge while it does.
      <div className="flex justify-center px-6 pb-10 sm:px-10 lg:h-full lg:items-start lg:px-0 lg:pb-8">
        <img
          src={clientAppMock}
          alt="The client app on a phone, showing a branded home screen with macro totals and a quick log for meals and water"
          className="h-auto w-[320px] max-w-full lg:h-full lg:w-auto lg:object-contain lg:object-top"
        />
      </div>
    }
  />
);

export default LaunchAppPage;
